import { render, staticRenderFns } from "./TeacherCourseQuizView.vue?vue&type=template&id=01f698cc"
import script from "./TeacherCourseQuizView.vue?vue&type=script&lang=js"
export * from "./TeacherCourseQuizView.vue?vue&type=script&lang=js"
import style0 from "./TeacherCourseQuizView.vue?vue&type=style&index=0&id=01f698cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports